import { render, staticRenderFns } from "./single-choice.vue?vue&type=template&id=5d5afe03&scoped=true"
import script from "./single-choice.vue?vue&type=script&lang=js"
export * from "./single-choice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5afe03",
  null
  
)

export default component.exports